// vue.config.js

module.exports = {
  publicPath: process.env.BASE_URL || '/',
  devServer: {
    historyApiFallback: true
  },
  css: {
    extract: {
      ignoreOrder: true
    },
    loaderOptions: {
      sass: {
        sassOptions: {
          quietDeps: true,
          silenceDeprecations: ['legacy-js-api', 'import', 'global-builtin', 'color-functions', 'slash-div']
        }
      },
      scss: {
        sassOptions: {
          quietDeps: true,
          silenceDeprecations: ['legacy-js-api', 'import', 'global-builtin', 'color-functions', 'slash-div']
        }
      }
    }
  },
  chainWebpack: config => {
    config.resolve.alias.set('vue', '@vue/compat');
    config.module
      .rule('vue')
      .use('vue-loader')
      .tap(options => ({
        ...options,
        compilerOptions: {
          compatConfig: {
            MODE: 2
          }
        }
      }));
  },
  configureWebpack: {
    performance: {
      hints: 'warning',
      maxAssetSize: 3145728,
      maxEntrypointSize: 3145728
    }
  },
  pwa: {
    workboxOptions: {
      skipWaiting: true
    }
  },
  transpileDependencies: ['fast-png', 'iobuffer']
};
